const i = (s) => {
  const e = new Image();
  e.src = s;
  const n = e.width;
  let a = e.height;
  return a = a + a, n > a;
}, o = /[\r\n%#()<>?[\\\]^`{|}]/g, t = "data:image/svg+xml";
function g(s) {
  let e = s;
  const n = s.substring(0, t.length) === t;
  return n && (e = e.substring(t.length)), e = e.replace(/>\s{1,}</g, "><"), e = e.replace(/\s{2,}/g, " "), `${n ? t : ""}${e.replace(o, encodeURIComponent)}`;
}
const c = new RegExp(/(mp4|mov|avi|webm|flv|wmv)/, "i"), r = new RegExp(/(obj|fbx|glb|gltf|gltf+json)/, "i"), l = new RegExp(/(gif|png|jpg|jpeg|svg|bmp|tif|tiff|raw)/, "i"), m = new RegExp(/(html)/, "i"), p = new RegExp(/(mp3|wav|aac|ogg|m4a|flac)/, "i"), f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SVGDataPrefix: t,
  encodeSVGDataString: g,
  is3DModel: r,
  isAudio: p,
  isHTML: m,
  isImage: l,
  isVideo: c,
  mediaIsLandscape: i
}, Symbol.toStringTag, { value: "Module" }));
export {
  t as S,
  i as a,
  r as b,
  l as c,
  m as d,
  g as e,
  p as f,
  c as i,
  f as m
};
